import axios from "./axios";
import language from "./language";

export default async function (phone_area_code: string, phone: string, password: string) {
    return await axios.post("user/login", {
        lang: language(),
        phone_area_code,
        user: phone,
        password,
        type: "phone",
        push_os: "web",
        //recaptcha_token: await window.grecaptcha.execute('6LdoWDIpAAAAAEaCpBaxQj_fm81y7SjBAZeAd_7f', { action: 'submit' })
        //recaptcha_token
    });
}